import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-71d325da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "port-info" }
const _hoisted_2 = { class: "port-num" }
const _hoisted_3 = {
  key: 0,
  class: "risk-detail"
}
const _hoisted_4 = {
  key: 1,
  class: "service-name"
}

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getRiskPortDisplayText } from '@/utils/port-risk-display'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { PortItem } from '@/views/dashboard/manage/port-manage/port-manage.service'

interface RankingItem {
  port_num: number
  process_name?: string
  risk_detail?: string
  system_type?: number
  count: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'risk-port-ranking-chart',
  props: {
    data: { default: () => [] }
  },
  emits: ["rowClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit

const props = __props

const loading = ref(false)
const { t, te } = useI18n()

const rankingData = computed(() => {
  return props.data.map(item => ({
    port_num: item.port_num,
    process_name: item.process_name,
    risk_detail: item.risk_detail,
    system_type: item.system_type,
    count: item.device_count || 0
  }))
})

function rankingRiskDetailText (item: RankingItem) {
  return getRiskPortDisplayText(t, te, item.port_num, item.system_type, item.risk_detail)
}

function onRowClick(item: RankingItem & { count?: number }) {
  const c = Number(item.count ?? 0)
  if (!Number.isFinite(c) || c <= 0) return
  const pn = Number(item.port_num)
  if (!Number.isFinite(pn)) return
  emit('rowClick', { port_num: pn })
}

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('portManage.riskPortTop5'),
    data: rankingData.value,
    "show-time-range": false,
    loading: loading.value,
    "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
    unit: _ctx.$t('portManage.unitTerminal'),
    "name-key": "port_num",
    "row-clickable": true,
    onItemClick: onRowClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    "item-name": _withCtx(({ item }: { item: RankingItem & { rank: number } }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.port_num), 1),
        (rankingRiskDetailText(item))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(rankingRiskDetailText(item)) + ") ", 1))
          : (item.process_name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(item.process_name) + ") ", 1))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "data", "loading", "unit"]))
}
}

})